import React from 'react';
import { useTheme } from '../../theme';
import HeroSearch from './HeroSearch';
import StatsStrip from './StatsStrip';
import HowItWorks from './HowItWorks';
import SampleTagPage from './SampleTagPage';
import ReunionStories from './ReunionStories';
import Privacy from './Privacy';
import LiveFeed from './LiveFeed';
import CTA from './CTA';

export default function Homepage() {
  const { p } = useTheme();

  return (
    <div style={{ minHeight: '100%', background: p.bg, color: p.text }}>
      <HeroSearch />
      <StatsStrip />
      <HowItWorks />
      <SampleTagPage />
      <ReunionStories />
      <Privacy />
      <LiveFeed />
      <CTA />
    </div>
  );
}
